module.exports = __webpack_public_path__ + "static/media/Our Services.5e59c00b.svg";